import React from 'react';
import { AiOutlineFileText } from 'react-icons/ai';

import Collapse from '~/components/Collapse';
import { Skeleton } from '~/components/utils';
import { useFiles } from '~/hooks/files';
import colors from '~/styles/colors';
import grid from '~/styles/grid';

import { Container, DownloadFileButton } from './styles';

interface IProcessFile {
  id: string;
  path: string;
}

interface FileDetailsProps {
  files: Array<IProcessFile>;
  loading?: boolean;
}

const FileDetails: React.FC<FileDetailsProps> = ({ files, loading }) => {
  const { handleDownloadFile } = useFiles();

  const getLink = (path: string) => path.split('/')[4];

  const renderSkeleton = (index: number) => (
    <DownloadFileButton key={`anexo_${index}`}>
      <Skeleton
        variant="circle"
        width={24}
        height={24}
        style={{ marginRight: grid.xs }}
      />
      <Skeleton variant="text" height={16} width={100} />
    </DownloadFileButton>
  );

  const renderFileLink = ({ id, path }: IProcessFile) => (
    <DownloadFileButton
      key={id}
      onClick={() => handleDownloadFile(getLink(path))}
    >
      <AiOutlineFileText size={24} color={colors.primary} />
      <span>{getLink(path)}</span>
    </DownloadFileButton>
  );

  return (
    <Collapse label={`Anexos (${files?.length ?? 0})`} defaultOpen={false}>
      <Container>
        {loading
          ? Array.from(Array(5)).map((_, index) => renderSkeleton(index))
          : files?.map((file) => renderFileLink(file))}
      </Container>
    </Collapse>
  );
};

export default FileDetails;
